var map = {
	"./amsterdam.jpeg": 2876,
	"./barcelona.jpeg": 9577,
	"./basel.jpeg": 3859,
	"./belgrad.jpeg": 4275,
	"./berlin.jpeg": 6456,
	"./bern.jpeg": 2041,
	"./biel.jpeg": 1888,
	"./bijelo polje.jpeg": 6839,
	"./bruessel.jpeg": 789,
	"./budapest.jpeg": 4446,
	"./bukarest.jpeg": 583,
	"./dublin.jpeg": 2814,
	"./esch-sur-alzette.jpeg": 7306,
	"./genf.jpeg": 1464,
	"./helsinki.jpeg": 241,
	"./kopenhagen.jpeg": 9380,
	"./kosice.jpeg": 7854,
	"./lausanne.jpeg": 3117,
	"./lissabon.jpeg": 4915,
	"./ljubljana.jpeg": 331,
	"./london.jpeg": 5542,
	"./lugano.jpeg": 2952,
	"./luzern.jpeg": 2410,
	"./nikosia.jpeg": 814,
	"./oslo.jpeg": 2135,
	"./paris.jpeg": 2375,
	"./plowdiw.jpeg": 7258,
	"./prag.jpeg": 9006,
	"./prizren.jpeg": 1690,
	"./reykjavik.jpeg": 6886,
	"./riga.jpeg": 1953,
	"./rom.jpeg": 4674,
	"./sarajewo.jpeg": 7158,
	"./schaan.jpeg": 9250,
	"./skopje.jpeg": 3824,
	"./split.jpeg": 7604,
	"./stettin.jpeg": 2717,
	"./stgallen.jpeg": 2200,
	"./stockholm.jpeg": 9560,
	"./tallinn.jpeg": 6406,
	"./thessaloniki.jpeg": 160,
	"./tirana.jpeg": 4647,
	"./valletta.jpeg": 9487,
	"./vilnius.jpeg": 4998,
	"./wien.jpeg": 1607,
	"./winterthur.jpeg": 8286,
	"./zurich.jpeg": 4235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2743;